module.exports = __webpack_public_path__ + "static/6-635e056600842345a26ca4cdf3d6e0f4.jpeg";